
import EventEmitter from 'eventemitter3';
import { createContext } from 'react';
export const eventEmitter  = new EventEmitter();
export const mainEventContext = createContext(eventEmitter)